import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './style.less';
import classNames from 'classnames';

class DayAvailability extends Component {
    static propTypes = {
        /** day as in day number within the month */
        day: PropTypes.number,
        /** The day that was selected - overide to  @homeaway/react-nav-calendar-month, it is supposed to be passed through react-date-picker */
        dayData: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]), // eslint-disable-line react/forbid-prop-types
        /** Is the date in the past? */
        isPast: PropTypes.bool,
    };

    render() {
        const {day, dayData, isPast} = this.props;
        const {inPast} = dayData;

        const dayClassName = classNames('day-availability', {
            'day-availability--disabled':
                inPast || (inPast !== false && isPast),
        });
        return (
            <div className={dayClassName}>
                <div className="day-availability__content">
                    <div className="day-availability__day">{day}</div>
                </div>
            </div>
        );
    }
}

// date can be clicked
DayAvailability.canClick = (props) => {
    const {isPast} = props;
    return !isPast;
};

// date can be clicked or spanned
DayAvailability.canHover = (props) => {
    const {dayData, isPast} = props;
    const {inPast} = dayData;

    return !(isPast || inPast);
};

export default DayAvailability;
